<template>
  <el-dialog
    title="发送记录"
    :visible.sync="dialogVisible"
    width="90%"
    top="5vh"
    custom-class="send-log-dialog"
    :close-on-click-modal="false"
    @close="handleClose"
  >
    <div v-if="contentPreview" class="content-preview">{{ contentPreview }}</div>
    <el-table
      v-loading="loading"
      :data="logList"
      :height="tableHeight"
      style="width: 100%"
    >
      <el-table-column label="发送方" min-width="120">
        <template slot-scope="scope">
          <div class="user-cell">
            <img
              v-if="scope.row.senderAvatar"
              :src="scope.row.senderAvatar"
              class="avatar"
            />
            <span>{{ scope.row.senderNickname || scope.row.idUser || '-' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="接收方" min-width="120">
        <template slot-scope="scope">
          <div class="user-cell">
            <img
              v-if="scope.row.receiverAvatar"
              :src="scope.row.receiverAvatar"
              class="avatar"
            />
            <span v-if="scope.row.receiverNickname">
              {{ scope.row.receiverNickname }}
              <span v-if="scope.row.idInterlocutor" class="user-id">({{ scope.row.idInterlocutor }})</span>
            </span>
            <span v-else>{{ scope.row.idInterlocutor || '-' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="类型" width="70" align="center">
        <template slot-scope="scope">
          {{ scope.row.sendType === 0 ? '邮件' : '消息' }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="70" align="center">
        <template slot-scope="scope">
          <span :class="scope.row.sendStatus === 0 ? 'status-success' : 'status-fail'">
            {{ scope.row.sendStatus === 0 ? '成功' : '失败' }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="sendContent" label="发送内容" min-width="200" show-overflow-tooltip />
      <el-table-column prop="failReason" label="失败原因" min-width="160" show-overflow-tooltip />
      <el-table-column prop="sendTime" label="发送时间" width="160" />
    </el-table>
    <div v-if="!loading && logList.length === 0" class="empty-tip">暂无发送记录</div>
  </el-dialog>
</template>

<script>
import { getSendLogByTemplateId } from '@/api/talkytimes/masSending';

export default {
  name: 'SendLogModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    templateId: {
      type: String,
      default: '',
    },
    contentPreview: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
      logList: [],
    };
  },
  computed: {
    tableHeight() {
      return 'calc(80vh - 160px)';
    },
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        if (!val) {
          this.$emit('close');
        }
      },
    },
  },
  watch: {
    visible(val) {
      if (val && this.templateId) {
        this.fetchSendLog();
      }
    },
  },
  methods: {
    fetchSendLog() {
      if (!this.templateId) return;
      this.loading = true;
      getSendLogByTemplateId({ templateId: this.templateId })
        .then((res) => {
          if (res.code === 200) {
            this.logList = res.rows || [];
          } else {
            this.logList = [];
            this.$message.error(res.msg || '获取发送记录失败');
          }
        })
        .catch(() => {
          this.logList = [];
          this.$message.error('获取发送记录失败');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleClose() {
      this.logList = [];
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.content-preview {
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #f5f7fa;
  border-radius: 6px;
  font-size: 13px;
  color: #606266;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user-cell {
  display: flex;
  align-items: center;
  gap: 6px;

  .avatar {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
  }

  .user-id {
    color: #909399;
    font-size: 12px;
  }
}

.status-success {
  color: #67c23a;
}

.status-fail {
  color: #f56c6c;
}

.empty-tip {
  text-align: center;
  color: #909399;
  padding: 24px 0;
}
</style>

<style lang="scss">
.send-log-dialog {
  max-width: 1400px;

  .el-dialog__body {
    padding-top: 10px;
  }
}
</style>
